import { SsmService } from "./ssm/ssmService";
import { makeAuthService } from "./authService";
import { StaticResourceService } from "../common/staticResources/StaticResourceService";
import { AuthService } from "@sportal/api";
import { APIConfig } from "./api.types";

export interface ThunkApi {
  api: Api;
}

export class Api {
  private readonly _ssm: SsmService;
  private readonly _auth: AuthService;
  private readonly _resources: StaticResourceService;

  constructor(config: APIConfig) {
    const { http, backendUrl } = config;

    this._ssm = new SsmService(config);
    this._auth = makeAuthService(http, backendUrl);
    this._resources = new StaticResourceService(config);
  }

  get ssm(): SsmService {
    return this._ssm;
  }

  get auth(): AuthService {
    return this._auth;
  }

  get resources(): StaticResourceService {
    return this._resources;
  }
}
